import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";

const LanguagesSection = () => {
  const { t, languages, lang, setLanguage } = useLanguage();

  return (
    <section id="languages" className="relative py-24 sm:py-32" data-testid="languages-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <Reveal className="text-center">
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-600">
            {t.languages.overline}
          </p>
          <h2 className="mx-auto mt-4 max-w-2xl font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            {t.languages.title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-slate-600 sm:text-lg">
            {t.languages.subtitle}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {languages.map((l, i) => (
            <Reveal key={l.code} delay={Math.min(i * 0.03, 0.5)} y={20}>
              <button
                data-testid={`language-tile-${l.code}`}
                onClick={() => setLanguage(l.code)}
                className={`w-full rounded-2xl border px-4 py-4 text-center transition-all duration-300 hover:-translate-y-1 ${
                  lang === l.code
                    ? "border-sky-600 bg-sky-600 text-white shadow-lg shadow-sky-600/25"
                    : "border-sky-100 bg-white text-slate-700 hover:border-amber-300 hover:bg-amber-50/50 hover:shadow-lg hover:shadow-amber-500/10"
                }`}
              >
                <span className="block truncate text-sm font-bold">{l.nativeName}</span>
                <span
                  className={`mt-0.5 block text-[11px] font-medium ${
                    lang === l.code ? "text-sky-100" : "text-slate-400"
                  }`}
                >
                  {l.name}
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LanguagesSection;
